import usePermissions from 'common/use-permissions'
import permissions from 'common/system-permissions'

export default () => usePermissions(permissions.MANAGE_COLLEGE_APPLICATION_ROUNDS)
